import type { NavbarToggleButtonProps } from '@carboncopyco/ui';
import { Navbar } from '@carboncopyco/ui';
import { forwardRef } from 'react';
import { useEditorLoaded } from '../../context/EditorSdkProvider';

export type EditorNavbarToggleButtonProps = Pick<
  NavbarToggleButtonProps,
  'onSelect' | 'label' | 'disabled' | 'icon' | 'tooltipMessage' | 'selected'
>;

export const EditorNavbarToggleButton = forwardRef<
  HTMLDivElement,
  EditorNavbarToggleButtonProps
>(({ onSelect, label, disabled, icon, tooltipMessage, selected }, ref) => {
  const isEditorLoaded = useEditorLoaded();

  return (
    <Navbar.ToggleButton
      label={label}
      ref={ref}
      onSelect={onSelect}
      disabled={!isEditorLoaded || disabled}
      icon={icon}
      tooltipMessage={tooltipMessage}
      selected={selected}
    />
  );
});
EditorNavbarToggleButton.displayName = 'EditorNavbarToggleButton';
